/// <reference path="./BasicDateBasedInput.ts" />

interface Date
{
	pattern( pattern: string ): string;
}

namespace ui
{
	export namespace Form
	{
		export class DateTimeInput
			extends BasicDateBasedInput
		{

			public constructor( value: Date, format: string, descriptor: IBasicInputDescriptor )
			{
				super( value.pattern( 'Y-m-dTh:i:s.u' ), format, descriptor, 'datetime-local', InputValueTypes.DATETIME );
			}

			public value( val: string | Date | null ): DateTimeInput
			{
				val = val instanceof Date ? val.pattern( 'Y-m-dTh:i:s.u' ) : val;

				return super.value( val ) as DateTimeInput;
			}

			public val(): string
			{
				return this.m_Root.val() as string;

				// var value = this.m_Root.val() as string;

				// if ( value === '' ) return '';

				// var val: Date = new Date( value );

				// return val.pattern( 'Y-m-dTH:i:s' );
			}

			public CheckIfValid() : boolean
			{
				if ( !super.CheckIfValid() )
				{
					return false;
				}

				if ( !this.required() || this.disabled() )
				{
					const val = this.val();

					if ( val === undefined )
					{
						this.m_Root.val( '' );
					}

					return true;
				}

				return Date.parse( ( this.m_Root.val() || '' ).toString() ) != NaN;
			}

		}

		export class DateInput
			extends BasicDateBasedInput
		{

			public constructor( value: Date | null, format: string, descriptor: IBasicInputDescriptor )
			{
				if (value === null)
				{
					super('', format, descriptor, 'date', InputValueTypes.DATE);
				} else {
					super( value.pattern( 'Y-m-d' ), format, descriptor, 'date', InputValueTypes.DATE );
				}
			}

			public value( val: string | Date | null ): DateInput
			{
				val = val instanceof Date ? val.pattern( 'Y-m-d' ) : val;

				return super.value( val ) as DateInput;
			}

			public val(): string
			{
				return this.m_Root.val() as string;
			}

			public CheckIfValid() : boolean
			{
				if ( !super.CheckIfValid() ) {
					return false;
				}

				let val = this.m_Root.val();

				if ( !this.required() || this.disabled() )
				{
					if ( val === undefined )
					{
						this.m_Root.val( '' );
					}

					return true;
				}

				if ( val === undefined || val === '' ) {
					return false;
				}

				if ( val instanceof Array ) {
					val = val.join( '' );
				}

				return Date.parse( val.toString() ) !== NaN;
			}
		}

		export class TimeInput
			extends BasicDateBasedInput
		{

			public constructor( value: Date, descriptor: IBasicInputDescriptor )
			{
				super(
					value.pattern( 'H:i' ),
					'H:i',
					((desc: IBasicInputDescriptor) => { desc.pattern = '^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$'; return desc; })(descriptor), // editing descriptor before using super
					'time',
					InputValueTypes.TIME
				);
			}

			public Initialize(): void
			{
				super.Initialize();
			}

			public value( val: string | Date | null ): TimeInput
			{
				val = val instanceof Date ? val.pattern( 'H:i' ) : val;

				return super.value( val ) as TimeInput;
			}

			public val(): string
			{
				return this.m_Root.val() as string;

				// var value = this.m_Root.val() as string;

				// if ( value === '' ) return '';

				// var val: Date = new Date( value );

				// return val.pattern( 'H:i:s' );
			}

			public CheckIfValid(): boolean
			{
				if ( !super.CheckIfValid() ) {
					return false;
				}

				return /^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test( this.val().toString() );
			}

		}

	}
}
